import { Box, Flex, Heading, Icon, Text } from "@chakra-ui/react";
import { AccordionRoot, AccordionItem, AccordionItemTrigger, AccordionItemContent } from "@/components/ui/accordion";
import { LuChevronDown } from "react-icons/lu";
import { useLandingTheme } from "../Index";

const faqItems = [
  {
    question: "Which calendars do you support?",
    answer:
      "Currently, we support Google Calendar with more integrations coming soon (Outlook, Apple Calendar, etc.). We are working hard to bring full synchronization to all major platforms.",
  },
  {
    question: "Will this conflict with my existing meetings?",
    answer:
      "Absolutely not. Muro is designed to work *around* your existing commitments. It identifies the free space and intelligently suggests or blocks focus time without overwriting your manually scheduled events.",
  },
  {
    question: "How much focus time will I get?",
    answer:
      "This depends on your schedule density and preferences. Users typically reclaim between 5-15 hours of high-quality focus time per week that was previously lost to fragmentation.",
  },
  {
    question: "Is my calendar data secure?",
    answer:
      "Security is our top priority. We use industry-standard encryption and only access the necessary data to schedule your blocks. We never sell your personal data.",
  },
];

export const FAQ = () => {
  const { theme, isDark } = useLandingTheme();

  return (
    <Box
      as="section"
      py={24}
      px={4}
      bg={isDark ? `${theme.surface}4d` : theme.surfaceMuted}
      borderTop="1px solid"
      borderColor={theme.border}
      id="faq"
      transition="background-color 0.3s"
    >
      <Box maxW="3xl" mx="auto" w="full">
        <Heading
          as="h2"
          fontSize={{ base: "3xl", md: "4xl" }}
          fontWeight="bold"
          color={theme.textPrimary}
          mb={12}
          textAlign="center"
        >
          Frequently Asked Questions
        </Heading>

        <AccordionRoot collapsible>
          <Flex direction="column" gap={4}>
            {faqItems.map((item, index) => (
              <AccordionItem
                key={index}
                value={String(index)}
                bg={isDark ? `${theme.surfaceMuted}4d` : theme.surface}
                border="1px solid"
                borderColor={theme.border}
                borderRadius="2xl"
                overflow="hidden"
                transition="all 0.3s"
                _open={{
                  bg: isDark ? `${theme.surfaceMuted}80` : theme.surface,
                  boxShadow: `0 10px 40px ${theme.primary}${isDark ? "1a" : "10"}`,
                  borderColor: `${theme.primary}40`,
                }}
              >
                <AccordionItemTrigger p={6} cursor="pointer" _hover={{ bg: "transparent" }}>
                  <Flex align="center" justify="space-between" w="full">
                    <Text fontSize="lg" color={theme.textPrimary} fontWeight="medium">
                      {item.question}
                    </Text>
                    <Icon
                      as={LuChevronDown}
                      boxSize={5}
                      color={theme.textSecondary}
                      transition="transform 0.3s"
                      css={{
                        "[data-state=open] &": {
                          transform: "rotate(180deg)",
                        },
                      }}
                    />
                  </Flex>
                </AccordionItemTrigger>
                <AccordionItemContent px={6} pb={6}>
                  <Text color={theme.textSecondary} lineHeight="relaxed">
                    {item.answer}
                  </Text>
                </AccordionItemContent>
              </AccordionItem>
            ))}
          </Flex>
        </AccordionRoot>
      </Box>
    </Box>
  );
};
